module.exports = __webpack_public_path__ + "static/media/bg-desk-water.5c6bb4dc.svg";